// ===========================================================================
// GESTIONE DELLE POPUP
// ===========================================================================


// Globals
const $popup = $('.popup');
const $overlay = $('.overlay');


// Funzione che blocca lo scroll del body da utilizzare all'apertura di
// popup o pannelli (menu) per impedire lo scroll della pagina.
// Per permettere lo scroll dell'elemento in focus (es. popup) creare un
// wrapper interno all'elemento popup con position: static.
function noScroll(status) {
  if ($(window).width() < 768) {
    if (parseInt(status, 10) === 1) {
      $('body').addClass('noscroll');
    } else if (parseInt(status, 10) === 0) {
      $('body').removeClass('noscroll');
    }
  }
}

function openPopup(target, overlay) {
  if ($popup.is(':visible') === true) {
    $popup.fadeOut(100); // controllo se ci sono popup aperte e le chiudo
  }
  if (overlay.is('visible') !== true) {
    overlay.fadeIn(200); // controllo se l'overlay è già attivato
  }
  target.fadeIn(200); // fade in della popup corretta
  noScroll(1); // attivo il noscroll sul body
}

function closePopup(target, overlay) {
  target.fadeOut(100);
  overlay.fadeOut(100);
  noScroll(0); // disattivo il noscroll sul body
}


// popup condizioni di vendita (checkout)
$('body').on('click', '.link-popup-condizioni-vendita', function () {
  openPopup($('#popup-condizioni'), $overlay);
});

// popup privacy (checkout)
$('body').on('click', '.link-popup-privacy', function () {
  openPopup($('#popup-privacy'), $overlay);
});

// cambio indirizzo di spedizione
$('body').on('click', '#changeAddressSpedNoReg', function () {
  openPopup($('#popup-spedizione'), $overlay);
  $('#Nazioni_ID_spedizione').trigger('change');
});

// popup confezione elegance
$('.btnPopupConfezioneRegalo').on('click', function () {
  openPopup($('#popup-elegance'), $overlay);
});

// popup misura anelli
$('body').on('click', '.open-popup-misura', function () {
  openPopup($('#popup-misura'), $overlay);
});

// chiudo le popup al click sull'overlay
$overlay.on('click', function () {
  closePopup($popup, $overlay);
});

// pulsante chiudi popup
$('body').on('click', '.close-popup', function () {
  closePopup($popup, $overlay);
});


// ============================================================================
// Nuova funzionalitò di aside
// ============================================================================
// Mostro il relativo aside usando il data-target
$('.aside-open').on('click', function () {
  $('.aside.active').removeClass('active');
  $('#' + $(this).data('target')).addClass('active');
  $('.overlay').fadeIn(200);
});

// Al click sul pulsante chiudo l'aside
$('.aside-close').on('click', function () {
  $('.aside.active').removeClass('active');
  $('.overlay').fadeOut(100);
});

// Al click sull'overlay chiudo tutti gli eventuali aside aperti
$('.overlay').on('click', function () {
  $('.aside.active').removeClass('active');
  $('.overlay').fadeOut(100);
});
